import React, { useCallback } from 'react';

import ModalFooterButton from 'components/Modal/ModalFooterButton';
import { Handle } from 'components/SocialAccountInfo';
import { Step } from 'components/SteppedModal';
import SwitchAccountMessage from 'components/SwitchAccountMessage';
import useThreadsAuthenticator, {
  UseThreadsAuthenticatorConfig,
} from 'hooks/useThreadsAuthenticator';
import useThreadsPostModalSelector from '../useThreadsPostModalSelector';
import { ThreadsPostModalSteps } from './types';

export interface UseSwitchAccountStepConfig
  extends Partial<Pick<UseThreadsAuthenticatorConfig, 'onError'>> {
  onSwitchAccount?: () => void;
  onSwitchAccountSuccess?: () => void;
}

export default function useSwitchAccountStep(
  config: UseSwitchAccountStepConfig = {},
): Step<ThreadsPostModalSteps> {
  const { onSwitchAccount, onSwitchAccountSuccess, onError } = config;
  const { username } = useThreadsPostModalSelector();

  const { authenticate, authenticating } = useThreadsAuthenticator({
    force: true,
    onAuthSuccess: onSwitchAccountSuccess,
    onError,
  });

  const handleAuthenticate = useCallback((): void => {
    onSwitchAccount();
    authenticate();
  }, [authenticate, onSwitchAccount]);

  return {
    id: 'switch',
    title: 'switch threads accounts',
    component: (
      <SwitchAccountMessage username={<Handle username={username} />} />
    ),
    renderFooterButtons: ({ cancel, submit }) => [
      <ModalFooterButton {...cancel} key="cancel">
        cancel
      </ModalFooterButton>,

      <ModalFooterButton
        {...submit}
        key="submit"
        theme="submit"
        disabled={authenticating}
        onClick={handleAuthenticate}
      >
        switch accounts
      </ModalFooterButton>,
    ],
  };
}
